import { CheckBoxInputTemplate, CheckBoxInputTemplateProps } from "./template";

export type CheckBoxInputProps = CheckBoxInputTemplateProps;

export const CheckBoxInput: React.FC<CheckBoxInputProps> = (props) => {
  return <CheckBoxInputTemplate {...props} />;
};
